import React, { forwardRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  useExaminationsActions,
  useAlerts,
  FILE_ID,
  FILE_URL,
  FILE_URL_EXPIRES,
  BUCKET,
  MIMETYPE,
  NAME,
  ORIGINAL_NAME,
} from 'store/examinations';
import Spinner from 'components/FullScreenSpinner';

import Pdf from './Pdf';
import { Container, Image } from './styles';

const GoogleCloudFilePreview = forwardRef(({ data, setImageUrl, className }, ref) => {
  const { loadFile } = useExaminationsActions();
  const { action, loading, success } = useAlerts(loadFile);
  const fileUrl = success || data[FILE_URL];
  const isLoading = !data[FILE_ID] || !fileUrl || loading;

  const onClick = useCallback(() => {
    if (data[MIMETYPE] === 'application/pdf') {
      window.open(fileUrl, '_blank');
    } else {
      setImageUrl(data[FILE_ID]);
    }
  }, [data, fileUrl, setImageUrl]);

  useEffect(() => {
    action(data);
  }, [action, data]);

  return (
    <Container ref={ref} type="button" onClick={onClick} disabled={isLoading} className={className}>
      {(isLoading && <Spinner size={40} />) || (data[MIMETYPE] === 'application/pdf' && <Pdf url={fileUrl} />) || (
        <Image src={fileUrl} alt={data[NAME]} />
      )}
    </Container>
  );
});

GoogleCloudFilePreview.defaultProps = { setImageUrl: () => {}, className: undefined };
GoogleCloudFilePreview.propTypes = {
  data: PropTypes.shape({
    [FILE_ID]: PropTypes.string.isRequired,
    [FILE_URL]: PropTypes.string,
    [FILE_URL_EXPIRES]: PropTypes.string,
    [BUCKET]: PropTypes.string.isRequired,
    [MIMETYPE]: PropTypes.string.isRequired,
    [NAME]: PropTypes.string.isRequired,
    [ORIGINAL_NAME]: PropTypes.string.isRequired,
  }).isRequired,
  setImageUrl: PropTypes.func,
  className: PropTypes.string,
};

export default GoogleCloudFilePreview;
